import React, {PureComponent} from "react"
import styled from "styled-components"

import {H3} from "@irati/ui/src//Typography/Heading"
import {Hr} from "@irati/ui/src/Layout"
import Markdown from "@irati/ui/src/Markdown"
import {Reward} from "@irati/types"
import {FormattedMessage} from "@irati/utils/lang"

interface Props {
  reward: Reward
}

const ImportantInfoUL = styled.ul`
  margin-bottom: 0;
  margin-left: -8px;
  padding-left: 12px;
`

const ImportantInfoLI = styled.li`
  position: relative;
  list-style-type: none;
  margin: 5px 0 5px 0.8em;
  &:before {
    border-radius: 50%;
    border: 3px solid #ff0000;
    content: "";
    height: 6px;
    line-height: 18px;
    margin-left: -16px;
    position: absolute;
    top: 40%;
    width: 6px;
  }
  div,
  p {
    display: inline;
  }
`

export default class ImportantInfo extends PureComponent<Props> {
  render() {
    const {reward} = this.props

    return (
      <section>
        <H3>
          <FormattedMessage id="reward.importantInfo.header" />
        </H3>
        <Hr small />
        <ImportantInfoUL>
          {reward.importantInfo.map((info, index) => (
            <ImportantInfoLI key={index}>
              <Markdown key={index} source={info} />
            </ImportantInfoLI>
          ))}
        </ImportantInfoUL>
      </section>
    )
  }
}
